/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://dxbyrit7mbfo5dnnujuyab4yde.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "liveStripe",
            "endpoint": "https://sf5s0gw5b0.execute-api.eu-west-1.amazonaws.com/staging",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:786796aa-9780-428b-9cee-36606056c80f",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_fsP6I8AcZ",
    "aws_user_pools_web_client_id": "4ocrlbbitmvb6etmo30j15prqo",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "exam13b83ff5e8104872923899ef9cc054c8145650-staging",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "predictions": {
        "convert": {
            "speechGenerator": {
                "region": "eu-west-1",
                "proxy": false,
                "defaults": {
                    "VoiceId": "Joanna",
                    "LanguageCode": "en-US"
                }
            }
        }
    }
};


export default awsmobile;
